export default __webpack_public_path__ + "static/linkedin-icon-032cf8a63be2f0f4d42571a0df1c7b87.png";